import React from "react";

import { InfoSmIcon as InfoSm } from "@packages/ds";
import { useIntl } from "react-intl";

import { IconControl } from "ds/Button";
import * as Dialog from "ds/Dialog";

const StandardUserMgmtMsg = () => {
  const intl = useIntl();
  return (
    <Dialog.Root>
      <Dialog.Trigger analyticId="order.detail.standard_user_management.dialog.content">
        <IconControl aria-label="info-trigger">
          <InfoSm />
        </IconControl>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Content>
          <Dialog.Title>
            {intl.formatMessage({
              id: "order.detail.standard_user_management.dialog.title"
            })}
          </Dialog.Title>
          <Dialog.Description>
            {intl.formatMessage({
              id: "order.detail.standard_user_management.dialog.content"
            })}
          </Dialog.Description>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default StandardUserMgmtMsg;
